import SlideshowSolicitationView from './SlideshowSolicitationView';

export default SlideshowSolicitationView;
